<template>
    <div>
         <div id="container" >
                 <Upload ref="upload"
                    class="upload-test"
                    :show-upload-list="false"
                    :before-upload="upload"
                    accept=".mp4,.pdf,.mp3" 
                    :data="dataOss"
                    :action="baseUrl"
                    :on-success="successValid" 
                    :on-progress="propressUpload"
                    :on-error="errorUpload" >
                    <Button type="primary" >点击上传</Button>
              </Upload>
              <span>{{percent}}</span>
               <span>（仅支持MP4,PDF,MP3文件，MP4文件请符合 < 500M、H264、720P）</span>
          </div>
    </div>
</template>
<script>
import plupload from "plupload";
import Until from '../api/Date';
export default {
      data() {
          return {
              aliyunOssToken:{},
              g_object_name:'',
              dataOss:{},
              FileList:[],
              percent:'',
              baseUrl:this.$baseImg
          }
      },
      mounted(){
          this.getToken();
      },
      methods:{
        async  upload(file){
            this.g_object_name = Until.dateFormat(new Date(), 'yyyyMMdd')+'/'+Until.randomString(20)+Until.get_suffix(file.name)
            this.addressOss = this.aliyunOssToken.host;//上传地址
            this.dataOss = {
                'key' : this.g_object_name,
                'policy': this.aliyunOssToken.policy,
                'OSSAccessKeyId': this.aliyunOssToken.accessid, 
                'success_action_status' : '200', //让服务端返回200,不然，默认会返回204
                'signature': this.aliyunOssToken.signature,
            };//上传额外参数
        },
        errorUpload(){
            this.$Message.error('上传失败')
        },
        successValid(res){
            var data={
                Url:this.g_object_name
            }
            setTimeout(()=>{
                this.$emit('func',data)
            },200)
        },
        propressUpload(event,file,fileList){
            this.percent=parseInt(event.percent)+'%';
        },
        getToken(){
            this.$fetch('api/manage.PersonCenter/getOSSConfig').then(res=>{
            if(res.code==1){
                this.aliyunOssToken=res.data;//获取直传秘钥
            }
            })
        },
      }

}
</script>
<style scoped lang="less">
#container{
    display: flex;
}

</style>



// WEBPACK FOOTER //
// src/components/OssUpload.vue